import { useStaticQuery } from "gatsby";
const useGetContactBoxIcon = () => { const { emailIcon, fbIcon, instaIcon } = useStaticQuery("3550719614"); return { emailIcon: emailIcon.publicURL, fbIcon: fbIcon.publicURL, instaIcon: instaIcon.publicURL }; };
export default useGetContactBoxIcon;
